import { ChangeEvent, useMemo } from 'react';
import { Colors, Select } from '@mercator-gcp/grout';
import type { TStartDate } from 'types/misc';

const PERIOD_OPTIONS = {
  '7_days_ago': { key: '7_days_ago', label: 'Last 7 days' },
  '30_days_ago': { key: '30_days_ago', label: 'Last 30 days' },
  '3_months_ago': { key: '3_months_ago', label: 'Last 3 months' },
  '6_months_ago': { key: '6_months_ago', label: 'Last 6 months' },
  '1_years_ago': { key: '1_years_ago', label: 'Last year' },
  '3_years_ago': { key: '3_years_ago', label: 'Last 3 years' },
  anytime: {
    key: '',
    label: 'Anytime',
  },
};

type Props = {
  value?: string;
  onChange: (value: TStartDate) => void;
  placeholder?: string;
  'aria-label'?: string;
};

const periodOptions = Object.values(PERIOD_OPTIONS).map((option) => ({
  value: option.key,
  label: option.label,
}));

const PastIntervalSelector = ({
  value,
  onChange,
  placeholder = '',
  'aria-label': ariaLabel,
}: Props) => {
  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value as TStartDate);
  };

  const sx = useMemo(() => {
    if (!value) {
      return { color: Colors.TextQuiet };
    }

    return undefined;
  }, [value]);

  return (
    <Select
      value={value || ''}
      onChange={handleChange}
      options={periodOptions}
      placeholder={placeholder}
      aria-label={ariaLabel}
      sx={sx}
    />
  );
};

export default PastIntervalSelector;
